import { render, staticRenderFns } from "./airdropPackage.vue?vue&type=template&id=43402b78&scoped=true"
import script from "./airdropPackage.vue?vue&type=script&lang=js"
export * from "./airdropPackage.vue?vue&type=script&lang=js"
import style0 from "./airdropPackage.vue?vue&type=style&index=0&id=43402b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43402b78",
  null
  
)

export default component.exports